exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/views/canhbao/popchitietsukiencongto/popchitietsukiencongto.component.scss
// module id = ../../../../../src/app/views/canhbao/popchitietsukiencongto/popchitietsukiencongto.component.scss
// module chunks = main